import TransponderRouter from 'components/transponder/TransponderRouter'
import { ReactElement } from 'react'

const Transponder = (): ReactElement => TransponderRouter()

export default Transponder
